const MAX_Z_INDEX = 1000000;        // Used to bring an active/hovered location to the top
const LOCATION_Z_INDEX = 100000;    // Used to keep Branch Locations above ATM markers

var allMarkers = [];
var markerLookup = {};
var avgLat = 0;
var avgLng = 0;
var bounds = null;
var map = null;

async function initMap() {
    const { Map, InfoWindow } = await google.maps.importLibrary("maps");
    bounds = new google.maps.LatLngBounds();
    var map = new Map(document.getElementById('map'), {
        center: { lat: mapLocations[0].Latitude, lng: mapLocations[0].Longitude },
        zoom: 13,
        mapId: "198b76f34fd6f2",
        styles: [{
                "featureType": "administrative",
                "elementType": "all",
                "stylers": [{
                    "visibility": "on"
                }]
            },
            {
                "featureType": "administrative",
                "elementType": "labels.text.fill",
                "stylers": [{
                        "color": "#565656"
                    },
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "all",
                "stylers": [{
                    "color": "#f2f2f2"
                }]
            },
            {
                "featureType": "landscape",
                "elementType": "geometry.fill",
                "stylers": [{
                    "color": "#f3f3f3"
                }]
            },
            {
                "featureType": "landscape",
                "elementType": "labels",
                "stylers": [{
                    "visibility": "on"
                }]
            },
            {
                "featureType": "landscape",
                "elementType": "labels.text.fill",
                "stylers": [{
                    "color": "#565656"
                }]
            },
            {
                "featureType": "poi",
                "elementType": "all",
                "stylers": [{
                    "visibility": "off"
                }]
            },
            {
                "featureType": "poi",
                "elementType": "geometry.fill",
                "stylers": [{
                        "visibility": "on"
                    },
                    {
                        "color": "#e1e1e1"
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "labels",
                "stylers": [{
                    "visibility": "off"
                }]
            },
            {
                "featureType": "poi.park",
                "elementType": "labels.text",
                "stylers": [{
                    "visibility": "on"
                }]
            },
            {
                "featureType": "poi.park",
                "elementType": "labels.text.fill",
                "stylers": [{
                    "color": "#afafaf"
                }]
            },
            {
                "featureType": "road",
                "elementType": "all",
                "stylers": [{
                        "saturation": -100
                    },
                    {
                        "lightness": 45
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "all",
                "stylers": [{
                    "visibility": "simplified"
                }]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry.fill",
                "stylers": [{
                        "color": "#d5d5d5"
                    },
                    {
                        "weight": "2.94"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "labels.icon",
                "stylers": [{
                    "visibility": "off"
                }]
            },
            {
                "featureType": "road.arterial",
                "elementType": "labels.icon",
                "stylers": [{
                    "visibility": "off"
                }]
            },
            {
                "featureType": "transit",
                "elementType": "all",
                "stylers": [{
                    "visibility": "off"
                }]
            },
            {
                "featureType": "transit",
                "elementType": "geometry.fill",
                "stylers": [{
                        "visibility": "on"
                    },
                    {
                        "color": "#ebebeb"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "all",
                "stylers": [{
                        "color": "#AAB8CE"
                    },
                    {
                        "visibility": "on"
                    }
                ]
            }
        ]
    });

    const infoWindow = new InfoWindow();

    for (var i = 0; i < mapLocations.length; i++) {
        if (mapLocations[i].Latitude && mapLocations[i].Longitude) {
            var latLng = new google.maps.LatLng(mapLocations[i].Latitude, mapLocations[i].Longitude);
            // init markers
            let markerImage = document.createElement('img');
            markerImage.src = mapLocations[i].IsATM ? '/static/images/icon-co-op-location-marker-red-sm.png' : '/static/images/icon-selco-location-marker-blue-sm.png';

            var marker = new google.maps.marker.AdvancedMarkerElement({
                position: new google.maps.LatLng(mapLocations[i].Latitude, mapLocations[i].Longitude),
                map: map,
                title: mapLocations[i].Title,
                content: markerImage,
                zIndex: mapLocations[i].IsATM ? null : LOCATION_Z_INDEX
            });
            bounds.extend(latLng);
            allMarkers.push(marker);
            markerLookup[mapLocations[i].ContentLink] = marker;

            (function (marker, i) {
                marker.addListener('click', () => {
                    resetAllMarkersToDefault();
                    infoWindow.close();
                    infoWindow.setContent(
                        '<div class="location-tooltip">' +
                            '<div class="location-tooltip__content">' +
                                '<div class="location-tooltip__body">' +
                                    '<h3 class="h4">' + mapLocations[i].Name +'</h3>' +
                                    '<span class="location-tooltip__address meta">' + mapLocations[i].Address + '</br>' +
                                     mapLocations[i].Address2 + '</span>' +
                                    '<div class="location-item__directions-wrap">' +
                                        '<img src="/static/images/icon-map-blue.png" alt="">' +
                                        '<a class="location-item__directions meta" href="https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(mapLocations[i].Address + "+" + mapLocations[i].Address2).replace(/%20/g, "+") +'" target="_blank">Get Directions</a>' +
                                    '</div>' +
                                '</div>' +
                                (mapLocations[i].Image !== null ?
                                    '<div class="location-tooltip__image">' +
                                        '<img src="' + mapLocations[i].Image + '" class="order-md-2" alt="" width="630" height="392">' +
                                    '</div>' 
                                : '')
                                 +
                            '</div>' +
                        '</div>'
                        );
                    infoWindow.open(map, marker);

                    map.setCenter({lat: marker.position.lat, lng: marker.position.lng});
                    
                    let markerImage = document.createElement('img');
                    markerImage.src = mapLocations[i].IsATM ? '/static/images/icon-co-op-location-marker-gold-sm.png' : '/static/images/icon-selco-location-marker-gold-sm.png';
                    marker.content = markerImage;
                    marker.zIndex = MAX_Z_INDEX;

                    var locationCard = document.querySelector("[data-location='" + mapLocations[i].ContentLink + "']");
                    var activeCard = $("[data-location='" + mapLocations[i].ContentLink + "']");

                    // locationCard.scrollIntoView({ behavior: "smooth", block: "center" });

                    var scrollTop = $(window).scrollTop(),
                        elementOffset = $(activeCard).offset().top,
                        distance = (elementOffset - scrollTop),
                        headHeight = 230, //base height of sticky header
                        headHeight = $('.site-header').height() + 30;
                    $('html, body').animate({
                        scrollTop: ($(activeCard).offset().top - headHeight)
                    }, 250);

                    var previousLocationId = $('.location-page__location-item.active[data-location]').data('location');

                    if (typeof previousLocationId !== 'undefined' && mapLocations[i].ContentLink !== previousLocationId) {
                        $('.location-page__location-item.active').removeClass('active');
                        var previousMarker = markerLookup[previousLocationId];
                        var mapLocation = mapLocations.find(x => x.Latitude === previousMarker.position.lat && x.Longitude === previousMarker.position.lng);
                        
                        let markerImage = document.createElement('img');
                        markerImage.src = mapLocation.IsATM ? '/static/images/icon-co-op-location-marker-red-sm.png' : '/static/images/icon-selco-location-marker-blue-sm.png';
                        
                        previousMarker.content = markerImage;
                        previousMarker.zIndex = previousMarker.IsATM ? null : LOCATION_Z_INDEX;
                    }

                    locationCard.classList.add("active");
                });
            })(marker, i);
        }
    }

    infoWindow.addListener('closeclick', () => {
        resetAllMarkersToDefault();
        $('.location-page__location-item.active').removeClass('active');
    });
}

function initEmptyMap() {
    // Styles the map.
    var map = new google.maps.Map(document.getElementById('map'), {
        center: {
            lat: 45.552304771688995,
            lng: -122.66164782399251
        },
        zoom: 13,
        mapId: "198b76f34fd6f2",
        styles: [{
                "featureType": "administrative",
                "elementType": "all",
                "stylers": [{
                    "visibility": "on"
                }]
            },
            {
                "featureType": "administrative",
                "elementType": "labels.text.fill",
                "stylers": [{
                        "color": "#565656"
                    },
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "all",
                "stylers": [{
                    "color": "#f2f2f2"
                }]
            },
            {
                "featureType": "landscape",
                "elementType": "geometry.fill",
                "stylers": [{
                    "color": "#f3f3f3"
                }]
            },
            {
                "featureType": "landscape",
                "elementType": "labels",
                "stylers": [{
                    "visibility": "on"
                }]
            },
            {
                "featureType": "landscape",
                "elementType": "labels.text.fill",
                "stylers": [{
                    "color": "#565656"
                }]
            },
            {
                "featureType": "poi",
                "elementType": "all",
                "stylers": [{
                    "visibility": "off"
                }]
            },
            {
                "featureType": "poi",
                "elementType": "geometry.fill",
                "stylers": [{
                        "visibility": "on"
                    },
                    {
                        "color": "#e1e1e1"
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "labels",
                "stylers": [{
                    "visibility": "off"
                }]
            },
            {
                "featureType": "poi.park",
                "elementType": "labels.text",
                "stylers": [{
                    "visibility": "on"
                }]
            },
            {
                "featureType": "poi.park",
                "elementType": "labels.text.fill",
                "stylers": [{
                    "color": "#afafaf"
                }]
            },
            {
                "featureType": "road",
                "elementType": "all",
                "stylers": [{
                        "saturation": -100
                    },
                    {
                        "lightness": 45
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "all",
                "stylers": [{
                    "visibility": "simplified"
                }]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry.fill",
                "stylers": [{
                        "color": "#d5d5d5"
                    },
                    {
                        "weight": "2.94"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "labels.icon",
                "stylers": [{
                    "visibility": "off"
                }]
            },
            {
                "featureType": "road.arterial",
                "elementType": "labels.icon",
                "stylers": [{
                    "visibility": "off"
                }]
            },
            {
                "featureType": "transit",
                "elementType": "all",
                "stylers": [{
                    "visibility": "off"
                }]
            },
            {
                "featureType": "transit",
                "elementType": "geometry.fill",
                "stylers": [{
                        "visibility": "on"
                    },
                    {
                        "color": "#ebebeb"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "all",
                "stylers": [{
                        "color": "#AAB8CE"
                    },
                    {
                        "visibility": "on"
                    }
                ]
            }
        ]
    });
}


function resetAllMarkersToDefault() {
    self.allMarkers.forEach(function (marker) {
        var mapLocation = mapLocations.find(x => x.Latitude === marker.position.lat && x.Longitude === marker.position.lng);

        let markerImage = document.createElement('img');
        markerImage.src = mapLocation.IsATM ? '/static/images/icon-co-op-location-marker-red-sm.png' : '/static/images/icon-selco-location-marker-blue-sm.png';

        marker.content = markerImage;
        marker.zIndex = mapLocation.IsATM ? null : LOCATION_Z_INDEX;
    });
}

function locationHover(e) {

    var locationId = $(this).data("location");
    var marker = markerLookup[locationId];
    var mapLocation = mapLocations.find(x => x.Latitude === marker.position.lat && x.Longitude === marker.position.lng);
    
    let markerImage = document.createElement('img');
    markerImage.src = mapLocation.IsATM ? '/static/images/icon-co-op-location-marker-red-sm.png' : '/static/images/icon-selco-location-marker-blue-sm.png';

    // When hovering over a location, bring its marker to the top
    if (e.type === "mouseenter") {
        marker.zIndex = MAX_Z_INDEX;
    }
    else if (!$(this).hasClass('active')) {
        marker.content = markerImage;
        marker.zIndex = mapLocation.IsATM ? null : LOCATION_Z_INDEX;
    }
}

$(document).ready(function () {

    if (typeof mapLocations !== 'undefined' && mapLocations.length) {
        initMap();
    }
    else{
        initEmptyMap();
    }

    $('.location-page__location-item').on('mouseenter mouseleave', locationHover);

    $('.location-item__name a').on('click', function (e) {
        $('.location-page__location-item.active').removeClass('active');
        e.preventDefault();
        var $this = $(this);
        var locationId = $this.closest('.location-page__location-item').data('location');
        var activeMarker = markerLookup[locationId];
        new google.maps.event.trigger(activeMarker, 'click');
    });

    $("#use-my-location").on('click', function () {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function (position) {
                if ($("#user-latitude").length) {
                    $("#user-latitude").val(position.coords.latitude);
                }
                else {
                    $('#location-search-form').prepend('<input id="user-latitude" type="hidden" name="latitude" value="' + position.coords.latitude + '" />');

                }
                if ($("#user-longitude").length) {
                    $('#user-longitude').val(position.coords.longitude);
                }
                else {
                    $('#location-search-form').prepend('<input id="user-longitude" type="hidden" name="longitude" value="' + position.coords.longitude + '" />');
                }
                $("#user-latitude").closest("form").submit();
            });
        } else {
            x.innerHTML = "Geolocation is not supported by this browser.";
        }
    });

    // toggle state of pediatrician filter button for FAD
    $("#atmToggle").on("click", function (e) {
        if ($(this).attr('aria-checked') === 'false') {
            $('#include-atm').val('false');
        } else {
            $('#include-atm').val('true')
        }
        $('#include-atm').closest("form").submit();
    });

});
